import AppData from '../../Model/MerchantAppData';
import DetectSunmiDevice from '../../app/Merchant/service/PrintService/DetectSunmiDevice';
import BaseFirebaseRepository from './BaseFirebaseRepository';

const instances = {}
const defaultInstanceKey = Math.random()
export default class SunmiPrintJobRepository extends BaseFirebaseRepository {
    /**
     * @param {*} app
     * @return {SunmiPrintJobRepository}
     */
    static getInstance(app) {
        if (app == null) {
            // By default, use instance created from main App
            app = AppData.context || defaultInstanceKey
        }
        if (app != null && instances[app] == null) {
            // Create a new instance
            instances[app] = new SunmiPrintJobRepository(app)
        }
        return instances[app]
    }
    constructor(app) {
        super(app)
    }
    getRef = () => {
        if (!merchant_id) {
            throw "Invalid 'merchant_id'"
        }
        if (!DetectSunmiDevice.sunmiDevice.serialNumber) {
            throw "Invalid 'sunmi_printer_serial_number'"
        }
        // Load print jobs by matching merchant id and printer serial number
        return firebase.database().ref(firebase_path + '/sunmi_print_jobs/')
            .orderByChild("merchant_id_printer_serial_number")
            .equalTo(`${merchant_id}_${DetectSunmiDevice.sunmiDevice.serialNumber}`)
    }
    getBaseObject = () => {
        return {}
    }
    getBaseObject = () => {
        return {}
    }

    logChildRemoved = (item) => {
        console.log(`Print job removed, ${item.id}`)
    }

    setJobPrinted = (printJobId, status = '') => {
        return new Promise((resolve, reject) => {
            $.ajax({
                url     : `/merchant/api/sunmi_print_job/${printJobId}/set_printed`,
                type    : 'post',
                data    : {
                    status
                },
                success : () => {
                    resolve()
                }
            })
            .fail(jqXHR => {
                if(jqXHR && jqXHR.statusText == 'abort') { return } // Cause by manual abort, no need show error

                let message = ""
                try {
                    let json = JSON.parse(jqXHR.responseText)
                    message = json["message"] || json[Object.keys(json)[0]] || "Fail to set print job as printed."
                }
                catch {

                }
                reject(message)
            })
        })
    }
}